import { render } from "./Bucket.vue?vue&type=template&id=54efe2cf&scoped=true"
import script from "./Bucket.vue?vue&type=script&lang=js"
export * from "./Bucket.vue?vue&type=script&lang=js"

import "./Bucket.vue?vue&type=style&index=0&id=54efe2cf&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-54efe2cf"]])

export default __exports__